import PropTypes from "prop-types";

import InputDropDown from "../../../ui/InputDropDowns";
import AadtInputGroup from "./AadtInputGroup";
import { SafetyFacilityType } from "../../../calculations/safety/SPFConstants";
import { INTX_TYPES } from "../../../constants/intxConstants";
import ObservedCrashesFields from "./ObservedCrashesFields";

const FACILITY_TYPE_TO_LABEL = {
  [SafetyFacilityType.RURAL_MULTILANE_HIGHWAY]: "Rural Multilane Highway",
  [SafetyFacilityType.TWO_LANE_RURAL_ROADWAY]: "Two-Lane Rural Roadway",
  [SafetyFacilityType.URBAN_SUBURBAN_COLLECTOR]: "Urban-Suburban Collector",
  [SafetyFacilityType.URBAN_SUBURBAN_ARTERIAL]: "Urban-Surburban Arterial",
};
export default function AtGradeGlobalSafetyDataFields({
  defaultValues,
  errors,
  formData,
  hasCurrentIntersection,
  intersectionTypes,
  register,
}) {
  const facilityTypeOptions = [
    SafetyFacilityType.TWO_LANE_RURAL_ROADWAY,
    SafetyFacilityType.RURAL_MULTILANE_HIGHWAY,
    SafetyFacilityType.URBAN_SUBURBAN_ARTERIAL,
    SafetyFacilityType.URBAN_SUBURBAN_COLLECTOR,
  ].map((type) => {
    const isRuralMultilaneHwyWithAwsc =
      type === SafetyFacilityType.RURAL_MULTILANE_HIGHWAY &&
      intersectionTypes.includes(INTX_TYPES.ALL_WAY_STOP);
    return {
      disabled: isRuralMultilaneHwyWithAwsc,
      helperText: isRuralMultilaneHwyWithAwsc
        ? "Cannot be used to analyze all way stop control"
        : "",
      value: type,
      label: FACILITY_TYPE_TO_LABEL[type],
    };
  });
  return (
    <>
      <InputDropDown
        defaultValue={
          defaultValues.safetyFacilityType ??
          SafetyFacilityType.TWO_LANE_RURAL_ROADWAY
        }
        errors={errors}
        name="safetyFacilityType"
        options={facilityTypeOptions}
        register={register}
        title="Facility Type"
        validate={(v) => facilityTypeOptions.some(({ value }) => value === v)}
      />
      <AadtInputGroup
        defaultValues={defaultValues}
        errors={errors}
        formData={formData}
        groups={[
          { id: "majorRoad", label: "Major road" },
          { id: "minorRoad", label: "Minor road" },
        ]}
        register={register}
      />
      {hasCurrentIntersection && (
        <ObservedCrashesFields
          defaultValues={defaultValues}
          errors={errors}
          formData={formData}
          register={register}
        />
      )}
    </>
  );
}

AtGradeGlobalSafetyDataFields.propTypes = {
  defaultValues: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  formData: PropTypes.object.isRequired,
  hasCurrentIntersection: PropTypes.bool.isRequired,
  intersectionTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  register: PropTypes.func.isRequired,
};
